import { render } from "./SegmentListPreview.vue?vue&type=template&id=ec373ab8&scoped=true&ts=true"
import script from "./SegmentListPreview.vue?vue&type=script&lang=ts"
export * from "./SegmentListPreview.vue?vue&type=script&lang=ts"

import "./SegmentListPreview.vue?vue&type=style&index=0&id=ec373ab8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec373ab8"]])

export default __exports__